export const RECIPIENTS = {
  lga: [
    {
      label: "Abeokuta-North",
      value: "Abeokuta_North",
    },
    {
      label: "Abeokuta-South",
      value: "Abeokuta_South",
    },
    {
      label: "Ado-Odo/Ota",
      value: "Ado_Odo/Ota",
    },
    {
      label: "Ewekoro",
      value: "Ewekoro",
    },
    {
      label: "Ifo",
      value: "Ifo",
    },
    {
      label: "Ijebu-East",
      value: "Ijebu_East",
    },
    {
      label: "Ijebu-North",
      value: "Ijebu_North",
    },
    {
      label: "Ijebu-North-East",
      value: "Ijebu_North_East",
    },
    {
      label: "Ijebu-Ode",
      value: "Ijebu_Ode",
    },
    {
      label: "Ikenne",
      value: "Ikenne",
    },
    {
      label: "Imeko-Afon",
      value: "Imeko_Afon",
    },
    {
      label: "Ipokia",
      value: "Ipokia",
    },
    {
      label: "Obafemi-Owode",
      value: "Obafemi_Owode",
    },
    {
      label: "Odeda",
      value: "Odeda",
    },
    {
      label: "Odogbolu",
      value: "Odogbolu",
    },
    {
      label: "Ogun-Waterside",
      value: "Ogun_Waterside",
    },
    {
      label: "Remo-North",
      value: "Remo_North",
    },
    {
      label: "Shagamu",
      value: "Shagamu",
    },
    {
      label: "Yewa North",
      value: "Yewa_North",
    },
    {
      label: "Yewa South",
      value: "Yewa_South",
    },
  ],
  category: [
    {
      label: "Farmers",
      value: "FARMER",
    },
    {
      label: "Marketer/Trader",
      value: "AGRO_MARKETER",
    },
    {
      label: "Processors",
      value: "PROCESSOR",
    },
    {
      label: "Off-takers",
      value: "OFFTAKER_AGGREGATOR",
    },
    {
      label: "Transport/Logistics",
      value: "AGRO_LOGISTICS_TRANSPORTER",
    },
    {
      label: "Extension Workers",
      value: "EXTENSION_SERVICES",
    },
    {
      label: "Mechanization Service",
      value: "MECHANIZATION_SERVICE_PROVIDERS",
    },
    {
      label: "Input Delears",
      value: "INPUT_DEALER",
    },
    {
      label: "Business Development Service",
      value: "BUSINESS_DEVELOPMENT_SERVICES",
    },
  ],
  commodity: [
    {
      label: "Cassava",
      value: "CASSAVA",
    },
    {
      label: "Banana",
      value: "BANANA",
    },
    {
      label: "Cocoa",
      value: "COCOA",
    },
    {
      label: "Potato",
      value: "POTATO",
    },
    {
      label: "Yam",
      value: "YAM",
    },
    {
      label: "Maize",
      value: "MAIZE",
    },
    {
      label: "Plantain",
      value: "PLANTAIN",
    },
    {
      label: "Sweet Potato",
      value: "SWEET_POTATO",
    },
    {
      label: "Cashew",
      value: "CASHEW",
    },
    {
      label: "Cowpea",
      value: "COWPEA",
    },
    {
      label: "Rice",
      value: "RICE",
    },
    {
      label: "Oil Palm",
      value: "OIL_PALM",
    },
    {
      label: "Wheat",
      value: "WHEAT",
    },
    {
      label: "Sesame",
      value: "SESAME",
    },
    {
      label: "Soya",
      value: "SOYA",
    },
    {
      label: "Cotton",
      value: "COTTON",
    },
    {
      label: "Horticulture",
      value: "HORTICULTURE",
    },
    {
      label: "Others",
      value: "OTHER",
    },
  ],
  purposeOfFarming: [
    {
      label: "Commercial",
      value: "COMMERCIAL",
    },
    {
      label: "Subsistence",
      value: "SUBSISTENCE",
    },
  ],
  typeOfFarming: [
    {
      label: "Crop Farming",
      value: "CROP_FARMING",
    },
    {
      label: "Livestocks",
      value: "LIVESTOCK_FARMING",
    },
  ],
  gender: [
    {
      label: "Female",
      value: "FEMALE",
    },
    {
      label: "Male",
      value: "MALE",
    },
  ],
  education: [
    {
      label: "Primary",
      value: "PRIMARY",
    },
    {
      label: "Secondary",
      value: "SECONDARY",
    },
    {
      label: "Tertiary",
      value: "TERTIARY",
    },
    {
      label: "No formal education",
      value: "NO_FORMAL_EDUCATION",
    },
  ],
  maritalStatus: [
    {
      label: "Single",
      value: "SINGLE",
    },
    {
      label: "Married",
      value: "MARRIED",
    },
    {
      label: "Divorced",
      value: "DIVORCED",
    },
    {
      label: "Widowed",
      value: "WIDOWED",
    },
  ],
  identificationDocument: [
    {
      label: "Voter's Card",
      value: "VOTERS_CARD",
    },
    {
      label: "Driver's License",
      value: "DRIVERS_LICENSE",
    },
    {
      label: "National Identification Number (NIN)",
      value: "NIN",
    },
    {
      label: "International Passport",
      value: "INTERNATIONAL_PASSPORT",
    },
  ],
};

export const TOOLS_CATEGORIES = [
  { value: "1", label: "Crops and livestock management" },
  { value: "2", label: "Market access" },
  { value: "3", label: "Data collection and analysis" },
  { value: "4", label: "Communication and extension" },
  { value: "5", label: "Precision agriculture" },
  { value: "6", label: "Supply chain and logistics" },
  { value: "7", label: "Financial and farm management" },
  { value: "8", label: "Climate-smart agriculture" },
  { value: "9", label: "Knowledge repositories" },
  { value: "10", label: "Monitoring and Evaluation" },
  { value: "11", label: "Training and capacity building" },
];

export const PUBLICATION_CATEGORIES = [
  {
    value: "production-management-practices",
    label: "Production and Management Practices",
  },
  { value: "training-materials", label: "Training Materials" },
  { value: "technology-innovations", label: "Technology and Innovations" },
  {
    value: "market-economic-information",
    label: "Market and Economic Information",
  },
  {
    value: "climate-environmental-information",
    label: "Climate and Environmental Information",
  },
  {
    value: "policy-regulatory-guidelines",
    label: "Policy and Regulatory Guidelines",
  },
];

export const PUBLICATION_DOC_TYPE = [
  { value: "pdf", label: "PDF" },
  { value: "doc", label: "Doc" },
  { value: "excel", label: "Excel sheet" },
];

export const AGRO_MARKETER_COMMODITY_OPTIONS = [
  { value: "FOOD_CROPS", label: "Food Crops" },
  { value: "LIVESTOCK", label: "Livestock" },
  { value: "FISHERY", label: "Fishery" },
  { value: "PROCESSED_FARM_PRODUCTS", label: "Processed Farm Products" },
  { value: "OTHERS", label: "Others" },
];

export const PROCESSOR_COMMODITY_OPTIONS = [
  { value: "CASSAVA", label: "Cassava" },
  { value: "YAM", label: "Yam" },
  { value: "COWPEA", label: "Cowpea" },
  { value: "BANANA", label: "Banana" },
  { value: "PLANTAIN", label: "Plantain" },
  { value: "RICE", label: "Rice" },
  { value: "COCOA", label: "Cocoa" },
  { value: "CASHEW", label: "Cashew" },
  { value: "OILPALM", label: "Oil Palm" },
  { value: "POTATO", label: "Potato" },
  { value: "SWEET_POTATO", label: "Sweet Potato" },
  { value: "WHEAT", label: "Wheat" },
  { value: "SESAME", label: "Sesame" },
  { value: "SOYA", label: "Soya" },
  { value: "MAIZE", label: "Maize" },
  { value: "COTTON", label: "Cotton" },
  { value: "HORTICULTURE", label: "Horticulture" },
  { value: "POULTRY", label: "Poultry" },
  { value: "FISHERY", label: "Fishery" },
  { value: "CATTLE", label: "Cattle" },
  { value: "PIGGERY", label: "Piggery" },
  { value: "SMALL_RUMINANTS", label: "Small ruminants" },
  { value: "RABBITRY", label: "Rabbitry" },
  { value: "SNAILRY", label: "Snailry" },
  { value: "GRASSCUTTER", label: "Grasscutter" },
  { value: "SERICULTURE", label: "Sericulture" },
  { value: "BEE_KEEPING", label: "Bee keeping" },
];

export const INPUT_DEALER_COMMODITY_OPTIONS = [
  { value: "FARM_TOOLS", label: "Farm Tools" },
  { value: "AGROCHEMICALS", label: "Agrochemicals" },
  { value: "FERTILIZERS", label: "Fertilizers" },
  { value: "FEED", label: "Feed" },
  { value: "OTHERS", label: "Others" },
];

export const OFFTAKER_COMMODITY_OPTIONS = [
  { value: "FOOD_CROPS", label: "Food crops" },
  { value: "CASH_CROPS", label: "Cash crops" },
  { value: "LIVESTOCK", label: "Livestock" },
  { value: "FISH", label: "Fish" },
  { value: "OTHERS", label: "Others" },
];

export const MECHANIZATION_SERVICE_COMMODITY_OPTIONS = [
  { value: "LAND_CLEARING", label: "Land clearing" },
  { value: "LAND_PREPARATION", label: "Land preparation" },
  { value: "PLANTING_AND_HARVESTING", label: "Planting and harvesting" },
  { value: "WEED_CONTROL", label: "Weed control" },
  { value: "PROCESS_AUTOMATION", label: "Process automation" },
];

export const AREAS_OF_SPECIALIZATION_OPTIONS = [
  { value: "AGRIBUSINESS", label: "Agribusiness" },
  { value: "AQUACULTURE", label: "Aquaculture" },
  { value: "CROPS", label: "Crops" },
  { value: "LIVESTOCK", label: "Livestock" },
  { value: "OTHERS", label: "Others" },
];

export const COMMOTITES_TRANSPORTED_OPTIONS = [
  { value: "AGROCHEMICALS_AND_INPUTS", label: "Agrochemicals and inputs" },
  { value: "FARM_PRODUCE", label: "Farm produce" },
  { value: "LIVESTOCK", label: "Livestock" },
  { value: "COLD_CHAIN", label: "Cold chain" },
  { value: "OTHERS", label: "Others" },
];

export const SECONDARY_CATEGORY_OPTIONS = [
  { value: "AGRO_MARKETER", label: "Agro Marketer" },
  { value: "PROCESSOR", label: "Processor" },
  { value: "INPUT_DEALER", label: "Input Dealer" },
  { value: "EXTENSION", label: "Extension" },
  { value: "BDS", label: "Business Development Service" },
  { value: "OFFTAKER", label: "Off-taker" },
  { value: "LOGISTIC", label: "Logistic" },
  { value: "MECHANIZATION_SERVICE", label: "Mechanization Service" },
];

export const LIVESTOCKS_OPTIONS = [
  {
    label: "Poultry",
    value: "POULTRY",
  },
  {
    label: "Fishery & Aquaculture",
    value: "FISHERY_AQUACULTURE",
  },
  {
    label: "Cattle",
    value: "CATTLE",
  },
  {
    label: "Piggery",
    value: "PIGGERY",
  },
  {
    label: "Small Ruminants (Goat, Sheep etc.)",
    value: "SMALL_RUMINANTS",
  },
  {
    label: "Rabbitry",
    value: "RABBITRY",
  },
  {
    label: "Snailry",
    value: "SNAILRY",
  },
  {
    label: "Grasscutter farming",
    value: "GRASSCUTTER_FARMING",
  },
  {
    label: "Sericulture (Silkworm production)",
    value: "SERICULTURE",
  },
  {
    label: "Bee-keeping",
    value: "BEE_KEEPING",
  },
  {
    label: "Other",
    value: "OTHER",
  },
];

export const YEARS_OPTIONS = Array.from(
  { length: new Date().getFullYear() - 1980 + 1 },
  (_, i) => 1980 + i
);

export const COOPERATIVE_MEMBERSHIP_OPTIONS = [
  { label: "Yes", value: "YES" },
  { label: "No", value: "NO" },
];

export const COOPERATIVE_BENEFIT_OPTIONS = [
  {
    label: "Access to credit",
    value: "ACCESS_TO_CREDIT",
  },
  {
    label: "Input supply",
    value: "INPUT_SUPPLY",
  },
  {
    label: "Marketing of produce",
    value: "MARKET_OF_PRODUCE",
  },
  {
    label: "Technical assistance",
    value: "TECHNICAL_ASSISTANCE",
  },
  {
    label: "Extension services",
    value: "EXTENSION_SERVICES",
  },
  {
    label: "Other",
    value: "OTHER",
  },
];

export const INTERNET_STREGTH_OPTIONS = [
  { label: "Low", value: "LOW" },
  { label: "Medium", value: "MEDIUM" },
  { label: "High", value: "HIGH" },
];

export const INFO_MEDIUM_OPTIONS = [
  { label: "Radio", value: "RADIO" },
  { label: "Television", value: "TELEVISION" },
  { label: "Mobile Phone", value: "MOBILE_PHONE" },
  { label: "Smartphone", value: "SMARTPHONE" },
  { label: "Newspaper", value: "NEWSPAPER" },
  { label: "Community group", value: "COMMUNITY_GROUP" },
  { label: "ADPs", value: "ADPS" },
  { label: "Other", value: "OTHER" },
];

export const OFFTAKE_CAPACITY_OPTIONS = [
  { label: ">100tons", value: "MORE_THAN_100_TONS" },
  { label: "10 - 100tons", value: "FROM_10_TO_100_TONS" },
  { label: "< 10tons", value: "LESS_THAN_10_TONS" },
];

export const BUSINESS_CATEGORY_OPTIONS = [
  { label: "Small", value: "SMALL" },
  { label: "Medium", value: "MEDIUM" },
  { label: "Large", value: "LARGE" },
];

export const DATA_COLLECTION_POINT_OPTIONS = [
  { label: "On the farm", value: "ON_THE_FARM" },
  { label: "Other location", value: "OTHER_LOCATION" },
];

export const AREA_OF_OPS_OPTIONS = [
  { label: "Intrastate", value: "INTRASTATE" },
  { label: "Interstate", value: "INTERSTATE" },
  { label: "International", value: "INTERNATIONAL" },
];

export const FARM_OWNERSHIP_OPTIONS = [
  { label: "Inherited", value: "INHERITED" },
  { label: "Purchased", value: "PURCHASED" },
  { label: "Lease", value: "LEASE" },
];

export const SEEDING_TYPE_OPTIONS = [
  { label: "Plant for seed", value: "PLANT_FOR_SEED" },
  { label: "Sell harvest as seed", value: "SELL_HARVEST_AS_SEED" },
];

export const SEEDING_YEAR_OPTIONS = [
  { label: "Less than 1 year ago", value: "LESS_THAN_1_YEAR" },
  { label: "1 year ago", value: "ONE_YEAR_AGO" },
  { label: "2 - 5 years ago", value: "TWO_TO_FIVE_YEARS" },
  { label: "5-10 years ago", value: "FIVE_TO_TEN_YEARS" },
  { label: "More than 10 years ago", value: "MORE_THAN_TEN_YEARS" },
  { label: "More than 20 years ago", value: "MORE_THAN_TWENTY_YEARS" },
];

export const SEEDING_OUT_OPTIONS = [
  { label: "Sell seed", value: "SELL_SEED" },
  { label: "Give for free", value: "GIVE_FOR_FREE" },
  { label: "Barter", value: "BARTER" },
];

export const VCDF_OPTIONS = [
  { label: "RBS", value: "RBS" },
  { label: "IITA", value: "IITA" },
  { label: "AgriQ", value: "AGRIQ" },
  { label: "OKD", value: "OKD" },
  { label: "NAMDAM", value: "NAMDAM" },
  { label: "Fish Shoal Nig", value: "FISH_SHOAL_NIG" },
  { label: "IBAD Ltd", value: "IBAD_LTD" },
  { label: "Neespree Ltd", value: "NEESPREE_LTD" },
];

export const EXPENDITURE_OPTIONS = [
  { label: "<100,000", value: "LESS_THAN_100K" },
  { label: "100,000 - 200,000", value: "100K_TO_200K" },
  { label: "200,000-300,000", value: "200K_TO_300K" },
  { label: "300,000 - 400,000", value: "300K_TO_400K" },
  { label: "400,000 - 500,000", value: "400K_TO_500K" },
  { label: ">500,000", value: "MORE_THAN_500K" },
];

export const CROP_FARMING_FORMS = [
  { name: "CASSAVA", label: "Cassava" },
  { name: "YAM", label: "Yam" },
  { name: "COWPEA", label: "Cowpea" },
  { name: "BANANA", label: "Banana" },
  { name: "PLANTAIN", label: "Plantain" },
  { name: "RICE", label: "Rice" },
  { name: "COCOA", label: "Cocoa" },
  { name: "CASHEW", label: "Cashew" },
  { name: "OILPALM", label: "Oil Palm" },
  { name: "POTATO", label: "Potato" },
  { name: "SWEETPOTATO", label: "Sweet Potato" },
  { name: "WHEAT", label: "Wheat" },
  { name: "SESAME", label: "Sesame" },
  { name: "SOYA", label: "Soya" },
  { name: "MAIZE", label: "Maize" },
  { name: "COTTON", label: "Cotton" },
  { name: "OTHER", label: "Other Crops" },
  { name: "HORTICULTURE", label: "Horticulture" },
];

export const LIVESTOCKS_FARMING_FORMS = [
  { name: "POULTRY", label: "Poultry" },
  { name: "FISHERY_AQUACULTURE", label: "Fishery & Aquaculture" },
  { name: "CATTLE", label: "Cattle" },
  { name: "PIGGERY", label: "Piggery" },
  { name: "SMALL_RUMINANTS", label: "Small Ruminants (Goat, Sheep etc.)" },
  { name: "RABBITRY", label: "Rabbitry" },
  { name: "SNAILRY", label: "Snailry" },
  { name: "GRASSCUTTER_FARMING", label: "Grasscutter farming" },
  { name: "SERICULTURE", label: "Sericulture (Silkworm production)" },
  { name: "BEE_KEEPING", label: "Bee-keeping" },
  { name: "OTHER", label: "Other Livestock" },
];

export const POULTRY_FARMING_OPTIONS = [
  { label: "Broilers", value: "BROILERS" },
  { label: "Layers", value: "LAYERS" },
];

export const RECIPIENTS_CUSTOM = {
  lga: [
    {
      label: "Abeokuta-North",
      value: "Abeokuta_North",
    },
    {
      label: "Abeokuta-South",
      value: "Abeokuta_South",
    },
    {
      label: "Ado-Odo/Ota",
      value: "Ado_Odo/Ota",
    },
    {
      label: "Ewekoro",
      value: "Ewekoro",
    },
    {
      label: "Ifo",
      value: "Ifo",
    },
    {
      label: "Ijebu-East",
      value: "Ijebu_East",
    },
    {
      label: "Ijebu-North",
      value: "Ijebu_North",
    },
    {
      label: "Ijebu-North-East",
      value: "Ijebu_North_East",
    },
    {
      label: "Ijebu-Ode",
      value: "Ijebu_Ode",
    },
    {
      label: "Ikenne",
      value: "Ikenne",
    },
    {
      label: "Imeko-Afon",
      value: "Imeko_Afon",
    },
    {
      label: "Ipokia",
      value: "Ipokia",
    },
    {
      label: "Obafemi-Owode",
      value: "Obafemi_Owode",
    },
    {
      label: "Odeda",
      value: "Odeda",
    },
    {
      label: "Odogbolu",
      value: "Odogbolu",
    },
    {
      label: "Ogun-Waterside",
      value: "Ogun_Waterside",
    },
    {
      label: "Remo-North",
      value: "Remo_North",
    },
    {
      label: "Shagamu",
      value: "Shagamu",
    },
    {
      label: "Yewa North",
      value: "Yewa_North",
    },
    {
      label: "Yewa South",
      value: "Yewa_South",
    },
  ],
  category: [
    {
      label: "All Farmers",
      value: "FARMER",
    },
    {
      label: "Crop Farmers",
      value: "FARMER.CROP_FARMING",
    },
    {
      label: "Livestock Farmers",
      value: "FARMER.LIVESTOCK_FARMING",
    },
    {
      label: "Marketer/Trader",
      value: "AGRO_MARKETER",
    },
    {
      label: "Processors",
      value: "PROCESSOR",
    },
    {
      label: "Off-takers",
      value: "OFFTAKER_AGGREGATOR",
    },
    {
      label: "Transport/Logistics",
      value: "AGRO_LOGISTICS_TRANSPORTER",
    },
    {
      label: "Extension Workers",
      value: "EXTENSION_SERVICES",
    },
    {
      label: "Mechanization Service",
      value: "MECHANIZATION_SERVICE_PROVIDERS",
    },
    {
      label: "Input Delears",
      value: "INPUT_DEALER",
    },
    {
      label: "Business Development Service",
      value: "BUSINESS_DEVELOPMENT_SERVICES",
    },
  ],
  commodity: [
    {
      label: "Cassava",
      value: "CASSAVA",
    },
    {
      label: "Banana",
      value: "BANANA",
    },
    {
      label: "Cocoa",
      value: "COCOA",
    },
    {
      label: "Potato",
      value: "POTATO",
    },
    {
      label: "Yam",
      value: "YAM",
    },
    {
      label: "Maize",
      value: "MAIZE",
    },
    {
      label: "Plantain",
      value: "PLANTAIN",
    },
    {
      label: "Sweet Potato",
      value: "SWEET_POTATO",
    },
    {
      label: "Cashew",
      value: "CASHEW",
    },
    {
      label: "Cowpea",
      value: "COWPEA",
    },
    {
      label: "Rice",
      value: "RICE",
    },
    {
      label: "Oil Palm",
      value: "OIL_PALM",
    },
    {
      label: "Wheat",
      value: "WHEAT",
    },
    {
      label: "Sesame",
      value: "SESAME",
    },
    {
      label: "Soya",
      value: "SOYA",
    },
    {
      label: "Cotton",
      value: "COTTON",
    },
    {
      label: "Horticulture",
      value: "HORTICULTURE",
    },
    {
      label: "Others",
      value: "OTHER",
    },
  ],
};

export const PUSH_NOTIFICATION_RECIPIENTS = [
  { label: "All users", value: "ALL" },
  { label: "Commodity", value: "COMMODITY" },
  { label: "Category", value: "CATEGORY" },
];

export const SMS_RECIPIENTS = [
  { label: "All users", value: "ALL" },
  { label: "Custom", value: "CUSTOM" },
  { label: "Commodity", value: "COMMODITY" },
  { label: "Category", value: "CATEGORY" },
];

export const EMAIL_RECIPIENTS = [
  { label: "All", value: "ALL" },
  { label: "Commodity", value: "COMMODITY" },
  { label: "Category", value: "CATEGORY" },
];

export const DIMENSION = {
  Desktop: "desktop",
  Tablet: "tablet",
  Mobile: "mobile",
};

export const LAYOUT = {
  Fluid: "fluid",
  Boxed: "boxed",
};

export const RADIUS = {
  Rounded: "rounded",
  Standard: "standard",
  Flat: "flat",
};

export const THEME_COLOR = {
  LightBlue: "light-blue",
  DarkBlue: "dark-blue",
  LightRed: "light-red",
  DarkRed: "dark-red",
  LightGreen: "light-green",
  DarkGreen: "dark-green",
  LightPurple: "light-purple",
  DarkPurple: "dark-purple",
  LightPink: "light-pink",
  DarkPink: "dark-pink",
};

export const NAV_COLOR = {
  Default: "default",
  Light: "light",
  Dark: "dark",
};

export const MENU_PLACEMENT = {
  Vertical: "vertical",
  Horizontal: "horizontal",
};

export const MENU_BEHAVIOUR = {
  Pinned: "pinned",
  Unpinned: "unpinned",
};
